import * as Yup from 'yup'

export const uploadNotaSchema = Yup.object().shape({
  pdf: Yup.mixed()
    .required('O PDF é obrigatório')
    .test('fileType', 'O arquivo deve ser um PDF', (value: File) => {
      return value && value.type === 'application/pdf'
    }),
  xml: Yup.mixed()
    .required('O XML é obrigatório')
    .test('fileType', 'O arquivo deve ser um XML', (value: File) => {
      return value && value.name.toLowerCase().endsWith('.xml')
    }),
})
